<template>
	<div class="box">
		<div class="padding pb-2 pt-0">
			<div class="py-3">
				<canvas id="chart-line" v-chartjs="loginsChart" style="height: 150px"></canvas>
			</div>
		</div>
	</div>
</template>

<style scoped>
a {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a:hover {
	opacity: 1;
}
table {
	width: 100%;
}
td {
	padding-bottom: 2rem;
}
</style>

<script>
import ReportingService from "@/services/ReportingService";
import fs from "@/services/FormatService";
import chartjs from "chart.js";
require("@/directives/chartjs");
import moment from "moment";

export default {
	name: "TrafficDashLogins",

	props: ["team"],

	data() {
		return {
			fs: fs,
			busy: false,
			totalTime: 0,
			totalScores: 0,
			loginsChart: {
				type: "line",
				data: {
					labels: ["S", "M", "T", "W", "T", "F", "S"],
					datasets: [
						{
							label: "Logins",
							data: [],
							fill: false,
							backgroundColor: "rgba(0, 188, 212, 0.1)",
							borderColor: "rgba(0, 188, 212, 0.25)",
							pointBorderColor: "rgba(0, 188, 212, 0.4)",
							borderWidth: 4,
							borderCapStyle: "butt",
							borderDash: [],
							borderDashOffset: 0.0,
							borderJoinStyle: "miter",
							pointBackgroundColor: "#fff",
							pointBorderWidth: 3,
							pointHoverRadius: 4,
							pointHoverBorderColor: "rgba(0, 188, 212, 0.8)",
							pointHoverBorderWidth: 3,
							pointRadius: [],
							pointHitRadius: 10,
							spanGaps: false,
							yAxisID: "logins"
						},
						{
							label: "System Time",
							data: [],
							fill: false,
							backgroundColor: "rgba(212, 148, 0, 0.1)",
							borderColor: "rgba(212, 148, 0, 0.25)",
							pointBorderColor: "rgba(212, 148, 0, 0.4)",
							borderWidth: 4,
							borderCapStyle: "butt",
							borderDash: [],
							borderDashOffset: 0.0,
							borderJoinStyle: "miter",
							pointBackgroundColor: "#fff",
							pointBorderWidth: 3,
							pointHoverRadius: 4,
							pointHoverBorderColor: "rgba(212, 148, 0, 0.8)",
							pointHoverBorderWidth: 3,
							pointRadius: [],
							pointHitRadius: 10,
							spanGaps: false,
							yAxisID: "time"
						}
					]
				},
				options: {
					tooltips: {
						mode: "point",
						displayColors: false,
						titleFontSize: 14,
						bodyFontSize: 14,
						callbacks: {
							title: (items, data) => {
								let i = items[0].index;
								let day = moment().day(i);
								return `${day.format("ddd l")}`;
							},
							label: (item, data) => {
								let i = item.datasetIndex;
								let j = item.index;
								let axis = data.datasets[i].yAxisID;
								let val = data.datasets[i].data[j];
								if (axis == "logins") {
									return `Logins: ${val}`;
								} else if (axis == "time") {
									return `System Time: ${fs.shortDuration(val)}`;
								}
							}
						}
					},
					maintainAspectRatio: false,
					scales: {
						xAxes: [
							{
								display: true
							}
						],
						yAxes: [
							{
								id: "logins",
								display: false,
								ticks: {
									suggestedMin: 0
								}
							},
							{
								id: "time",
								display: false,
								ticks: {
									suggestedMin: 0
								}
							}
						]
					},
					legend: {
						display: true
					},
					layout: {
						padding: {
							top: 10
						}
					}
				}
			}
		};
	},
	created() {
		this.loadData();
	},
	watch: {
		"team.id"() {
			this.loadData();
		}
	},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			let tid = this.team ? this.team.id : null;
			this.busy = true;
			ReportingService.getLoginVolume()
				.then(resp => {
					this.loadChartData(resp.data.daily_stats, resp.data.start_time, resp.data.end_time);
					this.totalTime = resp.data.total_time;
					this.totalLogins = resp.data.total_logins;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.busy = false;
				});
		},

		loadChartData(stats, start, end) {
			for (let d = 0; d < 7; d++) {
				console.log("load chart data", stats[d]);
				let day = moment(start).day(d);
				let isFuture = day.isAfter(moment(), "day");
				let logins = (stats[d] && stats[d].logins) || 0;
				let time = (stats[d] && stats[d].time) || 0;
				time = isNaN(time) ? 0 : time;
				time = time / 60000;
				if (isFuture) {
					logins = NaN;
					time = NaN;
				}

				this.loginsChart.data.datasets[0].data.push(logins);
				this.loginsChart.data.datasets[0].pointRadius.push(4);

				this.loginsChart.data.datasets[1].data.push(time);
				this.loginsChart.data.datasets[1].pointRadius.push(4);
			}

			document.getElementById("chart-line").$chart.update();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/TrafficDashboard/TrafficDashLogins.vue